/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Final_Cta_TitleInputs */

const en_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to take control?`)
};

const de_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit, die Kontrolle zu übernehmen?`)
};

const fr_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt à prendre le contrôle ?`)
};

const es_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Listo para tomar el control?`)
};

const it_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto a prendere il controllo?`)
};

const nl_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar om de regie te nemen?`)
};

const pl_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowy, aby przejąć kontrolę?`)
};

const fi_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oletko valmis ottamaan ohjat?`)
};

const da_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar til at tage kontrol?`)
};

const sv_landing_final_cta_title = /** @type {(inputs: Landing_Final_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo att ta kontroll?`)
};

/**
* | output |
* | --- |
* | "Ready to take control?" |
*
* @param {Landing_Final_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_final_cta_title = /** @type {((inputs?: Landing_Final_Cta_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Final_Cta_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_final_cta_title(inputs)
	if (locale === "fr") return fr_landing_final_cta_title(inputs)
	if (locale === "es") return es_landing_final_cta_title(inputs)
	if (locale === "it") return it_landing_final_cta_title(inputs)
	if (locale === "nl") return nl_landing_final_cta_title(inputs)
	if (locale === "pl") return pl_landing_final_cta_title(inputs)
	if (locale === "fi") return fi_landing_final_cta_title(inputs)
	if (locale === "da") return da_landing_final_cta_title(inputs)
	if (locale === "sv") return sv_landing_final_cta_title(inputs)
	return en_landing_final_cta_title(inputs)
});